module.exports = __webpack_public_path__ + "media/23.056645cd.mp3";